// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__qDV8n","mapboxgl-popup-content":"styles_mapboxgl-popup-content__l4Dgw"};